<template>
    <nav class="navbar navbar-light p-0 m-0">
        <div
            class="offcanvas offcanvas-end"
            tabindex="-1"
            id="offcanvasNavbar"
        >
            <div class="offcanvas-header">
                <h5 class="offcanvas-title">Settings</h5>
                <button
                    type="button"
                    class="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></button>
            </div>
            <div class="offcanvas-body">
                <ul class="navbar-nav justify-content-end flex-grow-1 pe-3 mb-3">
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" href="#">Menyu</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">Menyu</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="offcanvasNavbarDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >Menyu</a>
                        <ul class="dropdown-menu" aria-labelledby="offcanvasNavbarDropdown">
                            <li>
                                <a class="dropdown-item" href="#">Menyu</a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="#">Menyu</a>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <a class="dropdown-item" href="#">Menyu</a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <form class="d-flex">
                    <input
                        class="form-control me-2"
                        type="search"
                        :placeholder="TR.search"
                        aria-label="Search"
                    />
                    <button class="btn btn-primary" type="submit">
                        <i class="fas fa-search"></i>
                    </button>
                </form>
            </div>
        </div>
    </nav>
</template>

<script>
    import { ref, watchEffect } from "vue";

    import { useStore } from "@/store";

    export default {
        name: "OffCanvas",
        setup() {
            const store = useStore();

            const TR = ref();

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            return { TR };
        },
    };
</script>

